<div class="user-dashboard-container">
  <div class="user-layout" [class.nav-collapsed]="isSideNavCollapsed">
    <aside class="user-side-nav" [class.collapsed]="isSideNavCollapsed">
      <div class="side-nav-header">
        <span class="side-nav-title" *ngIf="!isSideNavCollapsed">Main Menu</span>
        <button type="button" class="side-nav-toggle" (click)="toggleSideNav()"
          [attr.aria-label]="isSideNavCollapsed ? 'Expand side navigation' : 'Collapse side navigation'">
          <mat-icon>{{ isSideNavCollapsed ? 'chevron_right' : 'chevron_left' }}</mat-icon>
        </button>
      </div>

      <nav class="user-tabs" role="tablist" aria-label="User screen tabs">
        <button type="button" class="tab-btn" *ngFor="let tab of userTabs"
          [id]="activeTab === tab ? 'tour-ud-active-tab' : null"
          [class.active]="activeTab === tab"
          [class.disabled]="isTabDisabled(tab)" [disabled]="isTabDisabled(tab)" [attr.aria-selected]="activeTab === tab"
          [attr.aria-disabled]="isTabDisabled(tab)" [attr.aria-label]="tab" (click)="setActiveTab(tab)">
          <mat-icon class="tab-icon">{{ getTabIcon(tab) }}</mat-icon>
          <span class="tab-label" *ngIf="!isSideNavCollapsed">{{ tab }}</span>
        </button>
      </nav>
    </aside>

    <main class="user-main-content">
      <section class="welcome-strip" aria-label="Welcome profile">
        <div class="welcome-top-row">
          <h1 class="welcome-title">Welcome, {{ displayUserName }}</h1>
        </div>
        <p class="welcome-subtitle">Here's your project overview and recent activities</p>
      </section>

      <div *ngIf="activeTab === 'Dashboard'">
        <div class="statistics-section">
          <div class="section-head-row">
            <h2 class="section-title">Dashboard Stats</h2>
          </div>

          <div class="stats-grid">
            <button type="button" class="stat-card" *ngFor="let stat of dashboardStats"
              [style.--stat-accent]="stat.color" [class.active-filter]="quickFilter === stat.key"
              (click)="setQuickFilter(stat.key)">
              <div class="stat-content">
                <div class="stat-value">{{ stat.value }}</div>
                <div class="stat-label">{{ stat.label }}</div>
              </div>
              <div class="stat-icon" [style.background]="stat.color">
                <mat-icon>{{ stat.icon }}</mat-icon>
              </div>
            </button>
          </div>
        </div>

        <div class="projects-section">
          <div class="section-head-row">
            <h2 class="section-title">Projects</h2>
          </div>

          <div class="dashboard-filters">
            <div class="dashboard-search">
              <mat-icon>search</mat-icon>
              <input type="text" placeholder="Search projects…" [(ngModel)]="dashboardSearchText">
              <button *ngIf="dashboardSearchText" type="button" class="dashboard-search-clear"
                (click)="dashboardSearchText = ''" aria-label="Clear search">
                <mat-icon>close</mat-icon>
              </button>
            </div>
            <button class="btn pill-btn flex-shrink-0 refresh" (click)="reloadPage()" title="Refresh">
              <mat-icon>refresh</mat-icon>
            </button>
            <select class="filter-dropdown" [(ngModel)]="quickFilter" (change)="setQuickFilter(quickFilter)">
              <option *ngFor="let option of filterOptions" [value]="option.value">
                {{ option.label }}
              </option>
            </select>
          </div>

          <!-- Pending Projects -->
          <div class="projects-list" *ngIf="pendingProjects.length > 0">
            <div class="project-card" *ngFor="let project of pendingProjects">
              <div class="project-header project-header-stack">
                <div class="project-title-group">
                  <h3 class="project-name">
                    <a class="project-name-link" (click)="viewProject(project.id, project.departmentId)">{{ project.name
                      }}</a>
                  </h3>
                </div>
              </div>

              <div class="project-details">
                <div class="detail-item">
                  <span class="detail-label">Collection Name</span>
                  <span class="detail-value">{{ project.collection || 'N/A' }}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">Sub-Collection</span>
                  <span class="detail-value">{{ getSubCollection(project.subCollections) }}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">Due Date</span>
                  <span class="detail-value">{{ formatDate(project.dueDate) }}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">Status</span>
                  <span class="detail-value">
                    <span class="status-badge" [ngClass]="getDisplayStatusClass(project)">
                      {{ getDisplayStatus(project) }}
                    </span>
                  </span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">Contact Person</span>
                  <span class="detail-value">{{ project.contactPerson || 'N/A' }}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">{{ getAssignmentLabel(project) }}</span>
                  <span class="detail-value">{{ getAssignedName(project) }}</span>
                </div>
              </div>

              <div class="due-progress-wrap" [ngClass]="getDueState(project)">
                <div class="due-progress-meta">
                  <span class="due-progress-label">Timeline</span>
                  <span class="due-progress-text">{{ getDueLabel(project) }}</span>
                </div>
                <div class="due-progress-track">
                  <div class="due-progress-bar" [style.width.%]="getDueProgress(project)"></div>
                </div>
              </div>

              <button class="btn btn-sm btn-outline-primary" (click)="viewProject(project.id, project.departmentId)">
                <mat-icon>visibility</mat-icon> View Project
              </button>
            </div>
          </div>

          <div class="info-box"
            *ngIf="!isLoading && pendingProjects.length === 0 && completedOrReviewProjects.length === 0">
            <mat-icon>info</mat-icon>
            <p>No projects available for this filter.</p>
          </div>

          <!-- Completed / Pending RAES Review Section -->
          <div *ngIf="completedOrReviewProjects.length > 0" class="completed-section">
            <div class="completed-section-header" (click)="completedSectionCollapsed = !completedSectionCollapsed">
              <div class="completed-section-title-group">
                <mat-icon class="completed-section-icon">check_circle</mat-icon>
                <h3 class="completed-section-title">Completed / Under Review Projects</h3>
              </div>
              <div class="completed-section-right">
                <span class="completed-section-count">{{ completedOrReviewProjects.length }}</span>
                <mat-icon class="completed-toggle-icon" [class.expanded]="!completedSectionCollapsed">
                  expand_more
                </mat-icon>
              </div>
            </div>

            <div class="completed-list" *ngIf="!completedSectionCollapsed">
              <div class="completed-card" *ngFor="let project of completedOrReviewProjects">
                <div class="completed-card-left">
                  <mat-icon class="completed-card-icon" [class.review-icon]="project.status === 'Pending RAES Review'">
                    {{ project.status === 'Completed' ? 'check_circle' : 'hourglass_top' }}
                  </mat-icon>
                  <div class="completed-card-info">
                    <a class="completed-card-name project-name-link"
                      (click)="viewProject(project.id, project.departmentId)">{{ project.name }}</a>
                    <span class="completed-card-collection">{{ project.collection || 'N/A' }}</span>
                  </div>
                </div>
                <div class="completed-card-right">
                  <span class="status-badge" [ngClass]="getDisplayStatusClass(project)">
                    {{ getDisplayStatus(project) }}
                  </span>
                  <span class="completed-card-date">{{ formatDate(project.dueDate) }}</span>
                  <button class="completed-view-btn" (click)="viewProject(project.id, project.departmentId)">
                    <mat-icon>visibility</mat-icon>
                    View
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <app-tutorial-video-widget
          screenId="user-dashboard"
          title="User Dashboard walkthrough"
          teaserDescription="Watch a quick walkthrough of this screen."
          storageKey="user-dashboard-tutorial-seen"
          teaserPosition="bottom-left"
          launcherPosition="bottom-left"
          [autoPlaySequence]="userWorkflowTutorialSequence"
          [allowLauncherDismiss]="true">
        </app-tutorial-video-widget>

      </div>

      <div *ngIf="activeTab === 'Manage Approval'" class="projects-section">
        <router-outlet></router-outlet>
      </div>

      <div *ngIf="activeTab === 'Manage Project'" class="projects-section">
        <div class="section-head-row">
          <h2 class="section-title">Manage Project</h2>
          <!-- <span class="filter-chip">Assignment & Documents</span> -->
        </div>

        <div class="filters-row">
          <div class="table-filter-container">
            <mat-icon class="search-icon">search</mat-icon>
            <input type="text" class="table-search-input" placeholder="Search projects..." [(ngModel)]="searchText"
              (keyup)="applyAllFilters()">
            <button *ngIf="searchText" type="button" class="clear-search-btn" (click)="clearSearch()">
              <mat-icon>close</mat-icon>
            </button>
          </div>

          <select class="filter-select status-filter" [(ngModel)]="selectedStatusFilter"
            (change)="applyStatusFilter(selectedStatusFilter)">
            <option *ngFor="let option of filterOptions" [value]="option.value">{{ option.label }}</option>
          </select>

          <select class="filter-select date-filter" [(ngModel)]="selectedDateFilter"
            (change)="applyDateFilter(selectedDateFilter)">
            <option *ngFor="let option of filterDateOptions" [value]="option.value">{{ option.label }}</option>
          </select>
        </div>

        <div class="table-container">
          <table mat-table [dataSource]="dataSource" matSort class="projects-table">

            <ng-container matColumnDef="projectName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 23%;">Project Name</th>
              <td mat-cell *matCellDef="let project" style="width: 23%;">
                <a class="project-name-link"
                  (click)="viewProject(project?.project_details_id, project?.department_id)">{{ project?.project_name
                  }}</a>
              </td>
            </ng-container>

            <ng-container matColumnDef="contactPerson">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 15%;">Contact Person</th>
              <td mat-cell *matCellDef="let project" style="width: 15%;">{{ project?.contact_person || 'N/A' }}</td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
              <td mat-cell *matCellDef="let project">
                <span class="status-badge" [ngClass]="getStatusBadgeClass(project?.sub_task_status)">
                  {{ project?.sub_task_status}}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="createdDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Created Date</th>
              <td mat-cell *matCellDef="let project">{{ project?.updated_at | date:'MM/dd/yyyy' }}</td>
            </ng-container>

            <ng-container matColumnDef="dueDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Due Date</th>
              <td mat-cell *matCellDef="let project">{{ formatDate(project?.due_date, 'short') }}</td>
            </ng-container>

            <ng-container matColumnDef="collection">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 20%;">Collection</th>
              <td mat-cell *matCellDef="let project" style="width: 20%;">{{ project?.collection_name }}</td>
            </ng-container>

            <ng-container matColumnDef="subCollection">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 20%;">Sub-Collection</th>
              <td mat-cell *matCellDef="let project" style="width: 20%;">{{ getSubCollection(project.sub_collection_name) }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <tr class="mat-row no-data-row" *matNoDataRow>
              <td class="mat-cell" [attr.colspan]="displayedColumns.length">
                <div class="no-data-message">
                  <mat-icon>info</mat-icon>
                  <p>No projects available</p>
                </div>
              </td>
            </tr>
          </table>

          <mat-paginator #paginator [pageSize]="9" [pageSizeOptions]="[9, 10, 20]" [length]="paginator?.length"
            showFirstLastButtons class="hidden-paginator">
          </mat-paginator>

          <div class="custom-paginator-wrapper">
            <div class="paginator-left">
              <span class="page-size-label">Showing {{ getStartIndex() }}–{{ getEndIndex() }} of {{ paginator?.length }}
                records</span>
            </div>

            <div class="paginator-center">
              <button class="page-nav-btn page-text-btn" [disabled]="paginator?.pageIndex === 0"
                (click)="paginator?.firstPage()" title="First page">
                First
              </button>

              <button class="page-nav-btn" [disabled]="paginator?.pageIndex === 0" (click)="paginator?.previousPage()"
                title="Previous page">
                <mat-icon>chevron_left</mat-icon>
              </button>

              <button *ngFor="let page of displayPageNumbers()" class="page-number-btn"
                [class.active]="paginator?.pageIndex === (page - 1)" (click)="goToPage(page - 1)">
                {{ page }}
              </button>

              <button class="page-nav-btn" [disabled]="paginator?.pageIndex >= (pageCount - 1)"
                (click)="paginator?.nextPage()" title="Next page">
                <mat-icon>chevron_right</mat-icon>
              </button>

              <button class="page-nav-btn page-text-btn" [disabled]="paginator?.pageIndex >= (pageCount - 1)"
                (click)="paginator?.lastPage()" title="Last page">
                Last
              </button>
            </div>

            <div class="paginator-right">
              <label class="page-size-label-text">Items per page:</label>
              <select class="page-size-select-custom" [value]="paginator?.pageSize"
                (change)="onPageSizeChange($event.target.value)">
                <option [value]="5">5</option>
                <option [value]="10">10</option>
                <option [value]="20">20</option>
              </select>
            </div>
          </div>
        </div>

        <app-tutorial-video-widget
          screenId="manage-project-user-dashboard"
          title="Manage Project walkthrough"
          teaserDescription="Watch a quick walkthrough of this screen."
          storageKey="manage-project-user-dashboard-tutorial-seen"
          teaserPosition="bottom-left"
          launcherPosition="bottom-left"
          [autoPlaySequence]="userWorkflowTutorialSequence"
          [allowLauncherDismiss]="true">
        </app-tutorial-video-widget>
      </div>

      <div *ngIf="activeTab === 'Help & Support'" class="projects-section">
        <h2 class="section-title help-title">Help Articles</h2>

        <div class="help-tabs-container">
          <div class="help-tab-content">
            <div class="help-contact-content">
              <div class="contact-section-heading">
                <h3 class="help-content-title help-content-title--accent">Contact Support</h3>
                <!-- <p class="contact-section-subtitle">Reach the support team directly.</p> -->
              </div>

              <div class="contact-card contact-card--support">
                <div class="contact-support-info">
                  <div class="contact-support-icon">
                    <mat-icon>mail_outline</mat-icon>
                  </div>

                  <div class="contact-support-copy">
                    <span class="contact-support-label">Email support</span>
                    <span class="contact-email">Cert_Support&#64;toyota.com</span>
                  </div>
                </div>

                <a href="mailto:Cert_Support@toyota.com" class="contact-email-action">
                  <mat-icon>near_me</mat-icon>
                  <span>Send email</span>
                </a>
              </div>

              <div class="contact-section-heading">
                <h3 class="help-content-title help-content-title--accent">Guides and tutorials</h3>
                <!-- <p class="contact-section-subtitle">Guides, process references, and video tutorials.</p> -->
              </div>

              <div class="contact-card contact-card--resources">
                <div class="resource-group resource-group--scrollable">
                  <div class="resource-list resource-list--cards">
                    <div class="resource-item resource-item--document" *ngFor="let resource of helpResources">
                      <div class="resource-item-body">
                        <div class="resource-card-top">
                          <div
                            class="resource-card-icon"
                            [class.resource-card-icon--document]="resource.resourceType === 'document'"
                            [class.resource-card-icon--video]="resource.resourceType === 'video'">
                            <mat-icon>{{ resource.icon }}</mat-icon> 
                          </div>
                          

                          <span
                            class="resource-card-tag"
                            [class.resource-card-tag--video]="resource.resourceType === 'video'">
                            {{ resource.resourceType === 'video' ? 'Video' : 'Document' }}
                          </span>
                        </div>

                        <div class="resource-item-title">{{ resource.title }}</div>
                        <p class="resource-card-description">{{ resource.description }}</p>

                        <div class="resource-card-footer">
                          <div class="resource-card-meta">
                            <span class="resource-card-meta-item" *ngFor="let meta of resource.metaItems"
                              [class.resource-card-meta-item--duration]="meta.icon === 'timer'">
                              <mat-icon>{{ meta.icon }}</mat-icon>
                              <span>{{ meta.label }}</span>
                            </span>
                          </div>

                          <div class="resource-card-action-link">
                            <button
                              type="button"
                              class="resource-card-action-button"
                              [attr.aria-label]="resource.resourceType === 'video' ? 'Watch ' + resource.title : 'Download ' + resource.title"
                              [class.resource-card-action-link--disabled]="resource.resourceType === 'video' && isOpeningVideo(resource.screenId || '')"
                              [disabled]="resource.resourceType === 'video' && isOpeningVideo(resource.screenId || '')"
                              (click)="!(resource.resourceType === 'video' && isOpeningVideo(resource.screenId || '')) && openHelpResource(resource)">
                              <span class="resource-inline-link">
                                {{ resource.resourceType === 'video'
                                  ? (isOpeningVideo(resource.screenId || '') ? 'Opening video...' : 'Watch')
                                  : 'Download' }}
                              </span>
                              <span class="resource-card-action-icon">
                                <ng-container *ngIf="resource.resourceType === 'video'; else resourceDownloadIcon">
                                  <svg
                                    class="resource-card-action-svg resource-card-action-svg--video"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="1.85"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    aria-hidden="true">
                                    <path d="M10 8.5 16 12l-6 3.5z"></path>
                                  </svg>
                                </ng-container>
                                <ng-template #resourceDownloadIcon>
                                  <svg
                                    class="resource-card-action-svg"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="1.95"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    aria-hidden="true">
                                    <path d="M12 4.75v9.25"></path>
                                    <path d="m8.75 10.9 3.25 3.35 3.25-3.35"></path>
                                    <path d="M7 18.25h10"></path>
                                  </svg>
                                </ng-template>
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</div>